import React from 'react';
import PropTypes from 'prop-types';
import styles from './Block.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';

function Block(props) {
  const {
    icon, text, onClick, active,
  } = props;

  return (
    <ClickableDiv className={`${styles.block} ${active ? styles.active : ''}`} onClick={onClick}>
      <div className={styles.icon}>
        <img src={icon} alt={text} />
      </div>
      <div className={styles.text}>
        {text}
      </div>
    </ClickableDiv>
  );
}

Block.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
};

Block.defaultProps = {
  active: false,
};

export default Block;
